export default __webpack_public_path__ + "static/media/home_9.ae6b1b6c.svg";